import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsightsComponent,ApiKeyDialog,OtpGenerateDialog } from './insights.component';
import {InsightsRoutingModule} from './insights-routing.module';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatDialogModule} from '@angular/material/dialog';
import { NgOtpInputModule } from  'ng-otp-input';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import { NgCircleProgressModule } from 'ng-circle-progress';
import {MatDividerModule} from '@angular/material/divider';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { NgChartsModule } from 'ng2-charts';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { AlertModule } from '../alert/alert.module';
import { LibModule } from '../lib/lib.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        InsightsComponent,
        ApiKeyDialog,
        OtpGenerateDialog
    ],
    imports: [
        CommonModule,
        InsightsRoutingModule,
        MatToolbarModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MatIconModule,
        MatInputModule,
        MatDialogModule,
        NgOtpInputModule,
        MatSnackBarModule,
        MatButtonModule,
        MatDividerModule,
        MatSelectModule,
        MatSlideToggleModule,
        NgChartsModule,
        NgbModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        NgxDaterangepickerMd.forRoot(),
        NgCircleProgressModule.forRoot({
            "radius": 50,
            "space": -8,
            "outerStrokeGradient": false,
            "outerStrokeWidth": 10,
            "outerStrokeColor": "#66EE8C",
            "innerStrokeColor": "#D7F2DE",
            "innerStrokeWidth": 10,
            "showSubtitle": false,
            "animation": true,
            "animateTitle": false,
            "animationDuration": 0,
            "showUnits": false,
            "showBackground": false,
            "clockwise": true,
            "startFromZero": false,
            "lazy": false
        }),
        AlertModule,
        LibModule,
        RouterModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InsightsModule { }
